import { BroadcastOnPersonal } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const UpdateGroupIcon = (props: SvgIconProps) => (<BroadcastOnPersonal {...props}/>);